import { EllipsisHorizontalIcon } from "@heroicons/react/24/outline";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuPortal,
  DropdownMenuTrigger,
} from "~/components/ui/dropdown-menu";

import { Button } from "./ui/button";

export default function EllipsisDropdownMenu({
  children,
  align = "end",
}: {
  children: React.ReactNode;
  align?: "start" | "center" | "end";
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon">
          <EllipsisHorizontalIcon data-testid="ellipsis-menu-trigger" className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuPortal>
        <DropdownMenuContent align={align}>{children}</DropdownMenuContent>
      </DropdownMenuPortal>
    </DropdownMenu>
  );
}
